import * as React from "react";

export const MethylationDetoxificationPhase2KeyContent = () => (
  <>
    <g id="Key">
              <rect width={1024} height={250} fill="white" />
        <g id="Container_2">
                <g id="key-item - Gene">
                  <rect x={40.5} y={66.5} width={386.748} height={183} stroke="#818181" />
                  <text
                    id="gene-label"
                    fill="#1A1A1A"
                    style={{ whiteSpace: "pre" }}
                    xmlSpace="preserve"
                    fontFamily="Gilroy W05 Bold"
                    fontSize={12}
            
                    letterSpacing="2.8px"
                  >
                    <tspan x={52.4383} y={86.4}>
                      GENETICS
                    </tspan>
                  </text>
                  <g id="Container_3">
                    <g id="Container_4">
                      <g id="Container_5">
                        <g id="Component 2">
                          <g id="gene-lozenge">
                            <path
                              d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                              fill="#E5E5E5"
                            />
                            <path
                              d="M56 96.3896H72C73.9941 96.3896 75.6104 98.0059 75.6104 100V116C75.6104 117.994 73.9941 119.61 72 119.61H56C54.0059 119.61 52.3896 117.994 52.3896 116V100C52.3896 98.0059 54.0059 96.3896 56 96.3896Z"
                              stroke="#1A1A1A"
                              strokeWidth={0.778643}
                            />
                          </g>
                        </g>
                        <text
                          id="Description"
                          fill="black"
                          style={{ whiteSpace: "pre" }}
                          xmlSpace="preserve"
                          fontFamily="Gilroy W05 Medium"
                          fontSize={14}
                  
                          letterSpacing="0em"
                        >
                          <tspan x={84.0723} y={112.767}>
                            Not included in panel
                          </tspan>
                        </text>
                      </g>
                      <g id="Container_6">
                        <g id="Component 2_2">
                          <g id="gene-lozenge_2">
                            <path
                              d="M52 128C52 125.791 53.7909 124 56 124H72C74.2091 124 76 125.791 76 128V144C76 146.209 74.2091 148 72 148H56C53.7909 148 52 146.209 52 144V128Z"
                              fill="#CCBAFF"
                            />
                          </g>
                        </g>
                        <text
                          id="Description_2"
                          fill="black"
                          style={{ whiteSpace: "pre" }}
                          xmlSpace="preserve"
                          fontFamily="Gilroy W05 Medium"
                          fontSize={14}
                  
                          letterSpacing="0em"
                        >
                          <tspan x={84.2559} y={140.767}>
                            No read
                          </tspan>
                        </text>
                      </g>
                      <g id="Container_7">
                        <g id="Component 2_3">
                          <g id="snp-indicator">
                            <path
                              id="Polygon 3"
                              d="M63.3387 158.372C63.6326 157.876 64.3674 157.876 64.6613 158.372L70.8966 168.885C71.1905 169.381 70.8231 170 70.2352 170H57.7648C57.1769 170 56.8095 169.381 57.1034 168.885L63.3387 158.372Z"
                              fill="#1A1A1A"
                            />
                          </g>
                        </g>
                        <text
                          id="Description_3"
                          fill="black"
                          style={{ whiteSpace: "pre" }}
                          xmlSpace="preserve"
                          fontFamily="Gilroy W05 Medium"
                          fontSize={14}
                  
                          letterSpacing="0em"
                        >
                          <tspan x={84.1738} y={168.767}>
                            Increased activity
                          </tspan>
                        </text>
                      </g>
                      <g id="Container_8">
                        <g id="Component 2_4">
                          <g id="snp-indicator_2">
                            <path
                              id="Polygon 3_2"
                              d="M64.6613 197.628C64.3674 198.124 63.6326 198.124 63.3387 197.628L57.1034 187.115C56.8095 186.619 57.1769 186 57.7648 186L70.2352 186C70.8231 186 71.1905 186.619 70.8966 187.115L64.6613 197.628Z"
                              fill="#1A1A1A"
                            />
                          </g>
                        </g>
                        <text
                          id="Description_4"
                          fill="black"
                          style={{ whiteSpace: "pre" }}
                          xmlSpace="preserve"
                          fontFamily="Gilroy W05 Medium"
                          fontSize={14}
                  
                          letterSpacing="0em"
                        >
                          <tspan x={84.2285} y={196.767}>
                            Decreased activity
                          </tspan>
                        </text>
                      </g>
                    </g>
                    <g id="Container_9">
                      <g id="Container_10">
                        <g id="Component 2_5">
                          <g id="gene-lozenge_3">
                            <path
                              d="M237 100C237 97.7909 238.791 96 241 96H257C259.209 96 261 97.7909 261 100V116C261 118.209 259.209 120 257 120H241C238.791 120 237 118.209 237 116V100Z"
                              fill="#00BF86"
                            />
                          </g>
                        </g>
                        <text
                          id="Risk description"
                          fill="black"
                          style={{ whiteSpace: "pre" }}
                          xmlSpace="preserve"
                          fontFamily="Gilroy W05 Medium"
                          fontSize={14}
                  
                          letterSpacing="0em"
                        >
                          <tspan x={269.288} y={112.767}>
                            0 risk alleles
                          </tspan>
                        </text>
                      </g>
                      <g id="Container_11">
                        <g id="Component 2_6">
                          <g id="gene-lozenge_4">
                            <path
                              d="M237 128C237 125.791 238.791 124 241 124H257C259.209 124 261 125.791 261 128V144C261 146.209 259.209 148 257 148H241C238.791 148 237 146.209 237 144V128Z"
                              fill="#FF905F"
                            />
                          </g>
                        </g>
                        <text
                          id="Risk description_2"
                          fill="black"
                          style={{ whiteSpace: "pre" }}
                          xmlSpace="preserve"
                          fontFamily="Gilroy W05 Medium"
                          fontSize={14}
                  
                          letterSpacing="0em"
                        >
                          <tspan x={269.271} y={140.767}>
                            1 risk allele
                          </tspan>
                        </text>
                      </g>
                      <g id="Container_12">
                        <g id="Component 2_7">
                          <g id="gene-lozenge_5">
                            <path
                              d="M237 156C237 153.791 238.791 152 241 152H257C259.209 152 261 153.791 261 156V172C261 174.209 259.209 176 257 176H241C238.791 176 237 174.209 237 172V156Z"
                              fill="#FF5D6D"
                            />
                          </g>
                        </g>
                        <text
                          id="Risk description_3"
                          fill="black"
                          style={{ whiteSpace: "pre" }}
                          xmlSpace="preserve"
                          fontFamily="Gilroy W05 Medium"
                          fontSize={14}
                  
                          letterSpacing="0em"
                        >
                          <tspan x={269.006} y={168.767}>
                            2 risk alleles
                          </tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                  <g id="key-item - Not included">
                    <g id="Icon">
                      <path
                        id="*"
                        d="M63.7483 224.79V227.209L59.8178 227.08L62.0638 230.319L59.861 231.615L57.8741 228.116L55.8873 231.615L53.6845 230.319L55.9305 227.08L52 227.209L52 224.79L55.9305 224.92L53.6845 221.681L55.8873 220.385L57.8741 223.883L59.861 220.385L62.0638 221.681L59.8178 224.92L63.7483 224.79Z"
                        fill="black"
                      />
                    </g>
                    <text
                      id="Explanation"
                      fill="black"
                      style={{ whiteSpace: "pre" }}
                      xmlSpace="preserve"
                      fontFamily="Gilroy W05 Medium"
                      fontSize={12}
              
                      letterSpacing="0px"
                    >
                      <tspan x={73.748} y={230.086}>
                        Limited / insufficient evidence for interpretation in this context
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
            </g>
  </>
);

const SvgMethylationDetoxificationPhase2Key = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={250}
    viewBox="0 0 1024 250"
    fill="none"
    {...props}
  >
    <MethylationDetoxificationPhase2KeyContent />
  </svg>
);

export default SvgMethylationDetoxificationPhase2Key;
